import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import Button from 'flarum/common/components/Button';
import Model from 'flarum/common/Model';
import Discussion from 'flarum/common/models/Discussion';
import PushFrontModal from 'flarum/forum/dianLiang/PushFrontModal';
import AlertUtil from 'flarum/forum/dianLiang/AlertUtil';
import PostControls from 'flarum/forum/utils/PostControls';

Discussion.prototype.frontpage = Model.attribute('frontpage');
Discussion.prototype.front = Model.attribute('front');

export default function addFrontPage() {
  // function pushFront(discussion,isFront) {
  //   if (app.session?.user?.isAdmin()) {
  //     discussion.save({ frontpage: isFront });
  //   } else {

  //   }
  // }
  
  extend(DiscussionControls, 'moderationControls', function (items, discussion) {
    let isFront = discussion.frontpage();
    if (discussion.front()) {
      items.add(
        'frontpage',
        Button.component(
          {
            icon: 'fas fa-home',
            onclick: () => {
              // isFront = !isFront;
              if (!isFront) {
                app.modal.show(PushFrontModal,{isFront:!isFront,discussion:discussion})
              } else {
                if (confirm(app.translator.trans('dl_discussion_controller.forum.pushFrontModal.comfirm_pull'))) {
                  discussion.save({ frontpage: !isFront}).then(() => {
                    let alertText = app.translator.trans('dl_discussion_controller.forum.pushFrontModal.submit_pull_success');
                    if (app.session?.user?.isAdmin()) {
                      alertText = app.translator.trans('dl_discussion_controller.forum.pushFrontModal.admin_submit_success');
                    }
                    m.redraw();
                    AlertUtil.onSuccess(app, alertText);
                    app.discussions.refresh();
                    this.loading = false;
                  });
                }
              }
              
              // this.pushFront(discussion,isFront);
            },
          },
          app.translator.trans(
            discussion.frontpage() ? 'dl_discussion_controller.forum.pull_to_index' : 'dl_discussion_controller.forum.push_to_index'
          )
        )
      );
    }
  });

  extend(PostControls, 'moderationControls', function (items, post) {
    let discussion = post.discussion();
    let isFront = discussion.frontpage();
    if (post.number() == 1 && discussion.front()) {
      items.add(
        'frontpage',
        Button.component(
          {
            icon: 'fas fa-home',
            onclick: () => {
              // isFront = !isFront;
              if (!isFront) {
                app.modal.show(PushFrontModal,{isFront:!isFront,discussion:discussion})
              } else {
                if (confirm(app.translator.trans('dl_discussion_controller.forum.pushFrontModal.comfirm_pull'))) {
                  discussion.save({ frontpage: !isFront}).then(() => {
                    let alertText = app.translator.trans('dl_discussion_controller.forum.pushFrontModal.submit_pull_success');
                    if (app.session?.user?.isAdmin()) {
                      alertText = app.translator.trans('dl_discussion_controller.forum.pushFrontModal.admin_submit_success');
                    }
                    m.redraw();
                    AlertUtil.onSuccess(app, alertText);
                    app.discussions.refresh();
                    this.loading = false;
                  });
                }
              }
              
              // this.pushFront(discussion,isFront);
            },
          },
          app.translator.trans(
            discussion.frontpage() ? 'dl_discussion_controller.forum.pull_to_index' : 'dl_discussion_controller.forum.push_to_index'
          )
        )
      );
    }
  });
}
